import * as React from 'react';
import { ANIMATION_DIRECTION } from '../constants';

const StepperContext = React.createContext(null);

const initialState = {
  currentPage: 0,
  visitedPage: 0,
  animationDirection: '',
  printerConfiguration: {
    allPrintersInfo: {},
    currentPart: 0,
    printerType: null,
    printerParts: null,
    clientValue: '',
  },
};

const updatePrinterStateConfig = (state, key, value) => ({
  ...state,
  printerConfiguration: {
    ...state.printerConfiguration,
    [key]: value,
  },
});

const stepperReducer = (state, action) => {
  switch (action.type) {
    case 'setCurrentPage':
      return {
        ...state,
        animationDirection: ANIMATION_DIRECTION.BACKWARD,
        currentPage: action.currentPage,
      };
    case 'next':
      return {
        ...state,
        currentPage: state.currentPage + 1,
        visitedPage:
          state.visitedPage > state.currentPage
            ? state.visitedPage
            : state.visitedPage + 1,
        animationDirection: ANIMATION_DIRECTION.FORWARD,
      };
    case 'previous':
      if (state.currentPage > 0) {
        return {
          ...state,
          currentPage: state.currentPage - 1,
          animationDirection: ANIMATION_DIRECTION.BACKWARD,
        };
      }
      return state;
    case 'setType':
      return updatePrinterStateConfig(state, 'printerType', action.printerType);
    case 'setPrintersInfo':
      return updatePrinterStateConfig(
        state,
        'allPrintersInfo',
        action.allPrintersInfo,
      );
    case 'setParts':
      return updatePrinterStateConfig(
        state,
        'printerParts',
        action.printerParts,
      );
    case 'setCurrentParts':
      return updatePrinterStateConfig(state, 'currentPart', action.currentPart);
    case 'setClientValue':
      return updatePrinterStateConfig(state, 'clientValue', action.clientValue);
    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
};

const StepperProvider = function ({ children }) {
  const [state, dispatch] = React.useReducer(stepperReducer, initialState);

  const value = { state, dispatch };
  return (
    <StepperContext.Provider value={value}>{children}</StepperContext.Provider>
  );
};

export { StepperContext, StepperProvider };
